import { action } from 'satcheljs';
export let openQuickSettings = action('OPEN_QUICK_SETTINGS');
